var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnImageAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 94,
    viewBox: "0 0 93 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 1.36719H78.03C85.6736 1.36719 91.87 7.56357 91.87 15.2072V78.8972C91.87 86.5408 85.6736 92.7372 78.03 92.7372H14.34C6.69638 92.7372 0.5 86.5408 0.5 78.8972V15.2072C0.5 7.56357 6.69638 1.36719 14.34 1.36719Z",
    fill: "#F7F7F7",
    stroke: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49.9461H50.5205V60.5781H42.4795V49.9461H32V43.2102H42.4795V32.5781H50.5205V43.2102H61V49.9461Z",
    fill: "#0D5CDD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnImageAdd);
export default __webpack_public_path__ + "static/media/btn_image_add.34063aeeeca091bd5fea2267b79f743c.svg";
export { ForwardRef as ReactComponent };